import { useMutation } from '@tanstack/vue-query'
import type { UpdateUserProfileDTO, User, UpdateProfileResponse } from '~/types'

export const useUpdateProfile = () => {
  const authStore = useAuthStore()
  return useMutation({
    mutationFn: async (payload: UpdateUserProfileDTO) =>
      await $fetch<User | UpdateProfileResponse>(`/api/user/${authStore.user?.id}`, {
        method: 'PATCH',
        body: JSON.stringify({ ...payload }),
        headers: {
          Authorization: `Bearer ${authStore.token}`,
        },
      }),
    onSuccess: (payload) => {
      if ('token' in payload && payload.token) {
        authStore.login(payload.token, payload.user)
      } else if ('user' in payload) {
        authStore.updateUser(payload.user)
      } else {
        authStore.updateUser(payload as User)
      }
    },
  })
}
